import { useEffect, useState } from "react";
import useQueryString from "../queryString/useQueryString";
import settlementsService from "../../services/settlementsService";
import useUser from "../user/useUser";
import { utils } from "../../utils/utils"

const initialfilters = {
  pageSize: 10,
  pageNumber: 1,
  from: "",
  to: "",
  terminalId: 0,
};

const useSettlements = () => {
  const { branch } = useUser();
  const [searchResult, setSearchResult] = useState({
    settlements: [],
    totalPage: 1,
    totalResults: 0,
  });

  const { filters, setParameterSearch, clearFilters } = useQueryString({
    ...initialfilters,
  });

  const [loading, setLoading] = useState(false);
  const [reload, setReload] = useState(false);


  useEffect(() => {
    const controller = new AbortController();
    const SearchSettlements = async (shouldLoad) => {
      setLoading(shouldLoad);
      settlementsService
        .Search({pvIds: branch.pvs.map((p) => p.id), ...filters}, { signal: controller.signal })
        .then((res) =>
          setSearchResult({
            settlements: res.values.map(s => ({ 
              ...s, 
              state: s.status, 
              displayTerminal: s.terminal?.terminalId,
              created: utils.convertUTCToArgentina(s.created)
            })),
            totalPage: res.totalPage,
            totalResults: res.totalResults,
          })
        )
        .finally(() => setLoading(false));
    };

    branch?.pvs?.length > 0 && SearchSettlements(true);

    return () => controller.abort();
  }, [filters, reload, branch?.pvs]);
  
  const forceReload = () => setReload(!reload);

  const create = async (terminalId, userEmail) => {
    const res = await settlementsService.Create({ terminalId, userEmail });

    forceReload();
    return res;
  };


  return {
    ...searchResult,
    loading,
    filters,
    clearFilters,
    setParameterSearch,
    create,
    forceReload
  };
};

export default useSettlements;
